// extracted by mini-css-extract-plugin
module.exports = {"blogs":"Blogs_blogs__3z8hG"};